import { render, staticRenderFns } from "./BlockFlexible.vue?vue&type=template&id=cfdf1fc6"
import script from "./BlockFlexible.vue?vue&type=script&lang=js"
export * from "./BlockFlexible.vue?vue&type=script&lang=js"
import style0 from "./BlockFlexible.vue?vue&type=style&index=0&id=cfdf1fc6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports